import {
  EntityTable,
  type AddRowConfig,
  type ColumnDef,
} from "@cmde/shadcn";
import { type UseQueryResult } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export function AppEntityTable<T, TError = Error>({
  queryResult,
  data,
  addRow,
  columns,
  getKey,
  loadingContent,
  errorContent,
  emptyContent,
  className,
  theadClassName,
  tbodyClassName,
}: {
  queryResult: UseQueryResult<T[] | undefined, TError>;
  data: T[];
  columns: ColumnDef<T>[];
  addRow?: AddRowConfig;
  getKey?: (item: T, index: number) => React.Key;
  loadingContent?: React.ReactNode;
  errorContent?: React.ReactNode;
  emptyContent?: React.ReactNode;
  className?: string;
  theadClassName?: string;
  tbodyClassName?: string;
}) {
  const { t } = useTranslation();

  const resolvedData = data ?? queryResult.data ?? [];

  return (
    <EntityTable
      data={resolvedData}
      columns={columns}
      getKey={getKey}
      isLoading={queryResult.isLoading}
      isError={queryResult.isError}
      loadingContent={loadingContent}
      errorContent={
        errorContent ?? <span>{t("common.somethingWentWrong")}</span>
      }
      emptyContent={emptyContent}
      addRow={addRow}
      className={className}
      theadClassName={theadClassName}
      tbodyClassName={tbodyClassName}
    />
  );
}
